<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <div fxFlex="20" class="u-text-left">
              <mat-card-title
                >{{ "module-assignment.salesforce_settings.api_details" | translate
                }}</mat-card-title
              >
            </div>
            <div fxFlex="80" class="u-text-right">
              <button
                [disabled]="action=='view' || isLoyaltySchemeImprintAddDisabled"
                mat-flat-button
                color="primary"
                (click)="openLoyaltySchemeImprintSelectApiPopup();"
              >
                {{ 'module-assignment.salesforce_settings.add' | translate}}
              </button>
            </div>
          </mat-card-header>
          <mat-card-content
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('loyaltySchemeApiDetails')['controls']; let i = index"
            formArrayName="loyaltySchemeApiDetails"
          >
            <div [formGroupName]="i">
              <div fxFlex="80">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ apiDetails.value.selectedApi}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            id="imprintUrl"
                            [required]="isRequired('url')"
                            formControlName="url"
                            matInput
                            [placeholder]="
                    'module-assignment.salesforce_settings.url' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <mat-select
                            id="ebasketMethod"
                            formControlName="method"
                            [placeholder]="
                      'magento.select_method' |
                      translate"
                          >
                            <mat-option
                              *ngFor="let methods of method_types"
                              [value]="methods.value"
                            >
                              {{methods.name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxFlex="20" class="u-text-right">
                <button
                  [disabled]="action=='view'"
                  mat-flat-button
                  color="primary"
                  (click)="deleteLoyaltySchemeImprintApiDetailContainer(i);"
                >
                  {{ 'module-assignment.salesforce_settings.delete' | translate}}
                </button>
              </div>
            </div>
          </mat-card-content>
          <div
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('loyaltySchemeApiDetails')['controls']; let i = index"
          >
            <mat-error *ngIf="!apiDetails.value.url && action !== 'view'">
              {{"module-assignment.salesforce_settings.api_details_required" | translate }}
            </mat-error>
          </div>
        </mat-card>
      </div>
      <!-- <mat-error *ngIf="!parentForm.valid || !isEBasketMixSaleSalesforceAddDisabled">
        {{ "module-assignment.salesforce_settings.auth_details_required" | translate }}
      </mat-error> -->
    </div>
  </div>
</div>
